import { render, staticRenderFns } from "./CustodyExpenseOperations.vue?vue&type=template&id=c095075c&"
import script from "./CustodyExpenseOperations.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports